module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/255-brazil-3c3ce45e634d071a8f3df6cd9691bd89.svg";